import $ from 'jquery';


export default () => {

    if ($('.blocco-informativo__slider--gallery').length > 0) {

        slide_gallery();
    }

    function slide_gallery() {
        var $status = $('.pagingInfo');
        $('.blocco-informativo__slider--gallery')
            .on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                if (!slick.$dots) {
                    return;
                }
                var i = (currentSlide ? currentSlide : 0) + 1;
                $status.text(i + '/' + (slick.$dots[0].children.length));
            })
            .slick({
                autoplay: false,
                dots: true,
                arrows: true,
                prevArrow: $('.blocco-informativo__slider').find('.arrow.arrow-left'),
                nextArrow: $('.blocco-informativo__slider').find('.arrow.arrow-right'),
                adaptiveHeight: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
            });

       
    }

};



// WEBPACK FOOTER //
// ./scripts/libs/blocco-informativo-slider.js